

<script>

import { mapActions, mapGetters } from 'vuex'
import { version } from '../../config'
import { http } from 'plugins/http'
import groupPermissions from 'plugins/grouppermissions';
import UTILITY from '../../utils/common.js'

export default {
	data() {
		return {
			user: {
				company: {
					name: ""
				}
			},
			selected_domain:'',
			hybrid_o365_verified:"",
			hybrid_exchange_verified:'',
			// actionRequiredCount:0,
			general_settings_permissions:false,
			personalise_settings_permissions:false,
			users_permissions:false,
			settings_permissions:false,
			checkInsightCondition:false,
			defaultPage:""
		}
	},
	computed: {
		/**
		 * See src/app/auth/vuex/getters.js
		 */
		...mapGetters(['currentUser', 'isLogged']),
		version() {
			return version
		},
	},

	beforeMount() {
		this.general_settings_permissions = groupPermissions('general_settings')
		this.personalise_settings_permissions = groupPermissions('personalize_settings')
		this.users_permissions = groupPermissions('users_permissions')
		this.esa = this.checkUserPermission('settings_insights');
		this.user = JSON.parse(localStorage.getItem('user'));
		// console.log(this.user)
		if (this.user.displaymode){
			$('body').addClass('dark_mode')
		}
		this.selected_domain = JSON.parse(localStorage.getItem('selected_domain'));	
		this.hybrid_o365_verified = this.$store.state.hybrid_o365_verified();
		this.hybrid_exchange_verified = this.$store.state.hybrid_exchange_verified();
		this.company_id = this.selected_domain.company_id;
		this.getDomains(this.company_id);
		this.getInsightStatus(this.selected_domain.domain,this.selected_domain.domain_provider)	
		this.defaultPage = UTILITY.getDefaultPage()
		// this.actionRequiredMails(this.selected_domain.domain);	
	},
	mounted() {
		this.user = JSON.parse(localStorage.getItem('user'));
		setTimeout(function(){
			// adding the script tag to the head as suggested before
			var head = document.getElementsByTagName('nav')[0];
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = '/static/pages/js/pages.js';
			// fire the loading
			if (script && head) {
				head.appendChild(script)
			};
			// require('../../../static/pages/js/pages.min.js');				
			if(!this.user){
				this.user = JSON.parse(localStorage.getItem('user'));
			}
		},1000);
	},
	methods: {
		checkUserPermission(name){
			let status = false;
			let user = JSON.parse(localStorage.getItem('user'));
			var index = ((user && user.permissions) || []).findIndex((obj => obj == name));
			if(index!=-1){
				status = true;
			}
			return status;
		},
		getDomains(cid){
			http.get('common/rules/getcompanydomain?cid='+cid).then(response => {
				if(response.data.status){
					this.domains = [];
					let domains = response.data.data;
					for(let i = 0; i<domains.length;i++){
						let domain = {};
						domain.id = domains[i]._id;
						domain.name = domains[i].domain;
						domain.provider = domains[i].domain_provider;
						domain.active_users = domains[i].active_users;
						domain.timezone = domains[i].timezone;
						domain.verified = domains[i].verified;
						domain.status = domains[i].status==1?true:false;
						domain.per = true;
						domain.subDomainProvider = domains[i].subDomainProvider;
						domain = JSON.parse(JSON.stringify(domain));
						this.domains.push(domain);
					}
				}
				this.updatedDomainDetail(this.domains);
			}).catch((e)=>{
				if(e && e.response && e.response.status === 403){
					this.removeItemFromLocalStorage()
				}
			})
		},
		getDomainDetail(domain_id){
			var domainindex = this.domains.findIndex((obj => obj.id == domain_id));
			return this.domains[domainindex];
		},
		updatedDomainDetail(domains){             
			let user = JSON.parse(localStorage.getItem('user'));
			for(let i=0; i<user.domains.length; i++){
				let updated_domain = this.getDomainDetail(user.domains[i].domain._id); 
				user.domains[i].domain.verified = updated_domain.verified;
				user.domains[i].domain.status = updated_domain.status;
			}
			UTILITY.setItemLocalStorage('user',JSON.stringify(user))
			this.changeSelectedDomain();
		},
		changeSelectedDomain(){
			let selected_domain = JSON.parse(localStorage.getItem('selected_domain'));
			let domainDetails = this.getDomainDetail(selected_domain._id);
			let newselectedDomain = {};
			newselectedDomain._id = domainDetails.id;
			newselectedDomain.domain = domainDetails.name;
			newselectedDomain.domain_provider = domainDetails.provider;
			newselectedDomain.company_id = selected_domain.company_id;
			newselectedDomain.active_users = domainDetails.active_users;
			newselectedDomain.verified = domainDetails.verified;
			newselectedDomain.timezone = domainDetails.timezone;
			newselectedDomain.status = domainDetails.status;
			newselectedDomain.createdAt = selected_domain.createdAt;
			newselectedDomain.subDomainProvider = domainDetails.subDomainProvider;

			UTILITY.setItemLocalStorage('selected_domain',JSON.stringify(newselectedDomain))
			this.selected_domain = JSON.parse(localStorage.getItem('selected_domain'));
		},
		// actionRequiredMails(domain){
		// 	http.get(`exchange/actionrequiredcount?domain=${domain}`).then(response => {
		// 		if(response.data.status){
		// 			this.actionRequiredCount = response.data.result;
		// 		}
		// 	}).catch((e)=>{});
		// },
		async getInsightStatus(domain,domain_provider){
			try{
				if(domain_provider == 1){
					this.checkInsightCondition = false;
					return
				}
				let response= await  http.get(`common/insights/getInsightMsgStatus?domain=${domain}&domain_provider=${domain_provider}`)
				if(response.data){
					let insightStatus= response.data.insightStatus;
					let status_SN = response.data.look_like_user_insight;
					let status_SD = response.data.look_like_domain_insight;
					let status_FT = response.data.first_email_insight;
					let status_HW = response.data.has_words_insight;
					this.checkInsightCondition = this.selected_domain.verified && this.checkUserPermission('settings_insights')&& insightStatus;
					if(this.checkInsightCondition){//check atleast 1 banner should be on
						this.checkInsightCondition =  status_SN || status_SD ||  status_FT ||  status_HW;
					}
				}
				return;
			}catch(e){
				console.log(e)
				return ;
			}
		}
	}
}
</script>


<template>
	<nav class="page-sidebar" data-pages="sidebar">   
	  <div class="sidebar-header">
	    <img src="/static/emailRemlogos/email_remediator_white.png" alt="logo" class="brand" data-src="/static/emailRemlogos/email_remediator_white.png">
	    	    <button aria-label="Pin Menu" type="button" class="btn btn-icon-link invert fixed_layout d-lg-inline-block d-xlg-inline-block d-md-inline-block d-sm-none d-none" data-toggle-pin="sidebar">
            <i class="pg-icon"></i>
          </button>
	  </div>
	  <div class="sidebar-menu">
	    <ul class="menu-items">
	        <router-link v-if ="defaultPage !=='admin_users'" tag="li" :to="{ name: 'dashboard'}" class="hide_after_click">
				<a><span class="title">Dashboard</span></a>
				<span class="icon-thumbnail"><i class="fas fa-home"></i></span>
	    	</router-link>

	    	<router-link tag="li" class="hide_after_click" :to="{ name: 'reported_mails'}" v-if="checkUserPermission('reported_mails')">
				<a>Reported Mails</a>
				<span class="icon-thumbnail"><i class="fas fa-envelope"></i></span>
	    	</router-link>

	    	<router-link tag="li" class="hide_after_click" :to="{ name: 'grecon'}" v-if="checkUserPermission('search_remediates_option') && (selected_domain.verified || hybrid_o365_verified || hybrid_exchange_verified)">
				<a>Search & Remediate</a>
				<span class="icon-thumbnail"><i class="fas fa-search"></i></span>
	    	</router-link>

			<!--<router-link tag="li" class="hide_after_click" :to="{ name: 'grecon'}" v-if="checkUserPermission('search_remediates_option') && selected_domain.verified">
	      	<a>Search & Remediate with folder</a>
	        <span class="icon-thumbnail"><i class="fas fa-search"></i></span>
	    	</router-link>-->

			<li v-if ="defaultPage !=='admin_users' && checkUserPermission('reports')">
				<a><span class="title">Visualizations</span>
				<span class="arrow"></span></a>
				<span class="icon-thumbnail"><i class="fas fa-chart-line"></i></span>
				<ul class="sub-menu">
					<router-link tag="li" class="hide_after_click" :to="{ name: 'stats', params: {type: 'stock'}}">
					<a>Stock Graph</a>
					<span class="icon-thumbnail"><i class="pg-icon">S</i></span>
				</router-link>
				<router-link tag="li" class="hide_after_click" :to="{ name: 'stats', params: {type: 'line'}}">
					<a>Line Graph</a>
					<span class="icon-thumbnail"><i class="pg-icon">L</i></span>
				</router-link>
				</ul>
			</li>

	      <li v-if="checkUserPermission('reports')">
	        <a><span class="title">Reports</span>
	        <span class="arrow"></span></a>
	        <span class="icon-thumbnail"><i class="fas fa-file-pdf"></i></span>
	        <ul class="sub-menu">
			    <router-link tag="li" class="hide_after_click" :to="{ name: 'reporting_trend'}">
					<a>Reporting Trend</a>
					<span class="icon-thumbnail"><i class="pg-icon">R</i></span>
				</router-link>

				<router-link tag="li" class="hide_after_click" :to="{ name: 'reporters_leaderboard'}">
					<a>Reporters Leaderboard</a>
					<span class="icon-thumbnail"><i class="pg-icon">R</i></span>
				</router-link>

				<router-link tag="li" class="hide_after_click" :to="{ name: 'manually_reported'}">
					<a>Remediation <small>(Manually Reported)</small></a>
					<span class="icon-thumbnail"><i class="pg-icon">M</i></span>
				</router-link>

				<router-link tag="li" class="hide_after_click" :to="{ name: 'remediation_threat_hunt'}">
					<a>Remediation <small>(Threat Hunt)</small></a>
					<span class="icon-thumbnail"><i class="pg-icon">R</i></span>
				</router-link>

				<router-link tag="li" class="hide_after_click" :to="{ name: 'remediation_auto_score_based'}" v-if="checkUserPermission('settings_insights')  && selected_domain.domain_provider !=1">
					<a>Remediation Auto Score Based</a>
					<span class="icon-thumbnail"><i class="pg-icon">R</i></span>
				</router-link>

	        	<router-link tag="li" class="hide_after_click" :to="{ name: 'exportreport'}">
					<a>User Report</a>
					<span class="icon-thumbnail"><i class="pg-icon">R</i></span>
				</router-link>

				<router-link tag="li" class="hide_after_click" :to="{ name: 'reviewmaillogs'}">
					<a>Admin Disposal</a>
					<span class="icon-thumbnail"><i class="pg-icon">A</i></span>
				</router-link>

				
				
				
				
				
	        </ul>
	      </li>

	      <li v-if="checkUserPermission('user') || checkUserPermission('settings_suppression_list')">
	        <a><span class="title">Users </span>
	        <span class="arrow"></span></a>
	        <span class="icon-thumbnail"><i class="fas fa-users"></i></span>
	        <ul class="sub-menu">
	        	<router-link tag="li" class="hide_after_click" :to="{ name: 'users'}" v-if="checkUserPermission('user_all_users')">
	            <a>All Users</a>
	            <span class="icon-thumbnail"><i class="pg-icon">A</i></span>
	          </router-link>
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'privilegedusers'}" v-if="checkUserPermission('user_privileged_users')">
	            <a>Privileged Users</a>
	            <span class="icon-thumbnail"><i class="pg-icon">P</i></span>
	          </router-link>
	          <!--<router-link tag="li" class="hide_after_click" :to="{ name: 'plugin_users'}" v-if="checkUserPermission('user_plugin_users')">
	            <a>Plugin Installed Users</a>
	            <span class="icon-thumbnail"><i class="pg-icon">P</i></span>
	          </router-link>-->
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'reported_users'}" v-if="checkUserPermission('user_reported_users')">
	            <a>Leaderboard</a>
	            <span class="icon-thumbnail"><i class="pg-icon">L</i></span>
	          </router-link>
			  		<router-link tag="li" class="hide_after_click" :to="{ name: 'suppression'}" v-if="checkUserPermission('settings_suppression_list')">
	            <a>Suppression Lists</a>
	            <span class="icon-thumbnail"><i class="pg-icon">S</i></span>
	          </router-link>
	        </ul>
	      </li>

	      <li v-if="checkUserPermission('integrations') ">
	        <a><span class="title">Integrations</span>
	        <span class="arrow"></span></a>
	        <span class="icon-thumbnail"><i class="fas fa-tools"></i></span>
	        <ul class="sub-menu">
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'integrations'}" v-if="checkUserPermission('integrations_digital_shadow') || checkUserPermission('integrations_google_safe_browsing') || checkUserPermission('integrations_virus_total')">
	            <a>Integration</a>
	            <span class="icon-thumbnail"><i class="pg-icon">I</i></span>
	          </router-link>
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'ciscoumbrella'}" v-if="checkUserPermission('integrations_cisco_umbrella')">
	            <a>Cisco Umbrella</a>
	            <span class="icon-thumbnail"><i class="pg-icon">C</i></span>
	          </router-link>
			   <router-link tag="li" class="hide_after_click" :to="{ name: 'infoblox'}" v-if="checkUserPermission('integrations_infoblox')">
	            <a>Infoblox</a>
	            <span class="icon-thumbnail"><i class="pg-icon">IB</i></span>
	          </router-link>
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'mimecast'}" v-if="checkUserPermission('integrations_mimecast')">
	            <a>Mimecast</a>
	            <span class="icon-thumbnail"><i class="pg-icon">M</i></span>
	          </router-link>
              <router-link tag="li" class="hide_after_click" :to="{ name: 'siem_integration'}" v-if="checkUserPermission('integrations_siem')">
	            <a>SIEM Integration</a>
	            <span class="icon-thumbnail"><i class="pg-icon">SI</i></span>
	          </router-link>
			  
	        </ul>
	      </li>

	      <li v-if="selected_domain.verified && selected_domain.domain_provider != 1 && checkUserPermission('audit')">
	        <a><span class="title">Audit Trails</span>
	        <span class="arrow"></span></a>
	        <span class="icon-thumbnail"><i class="fab fa-intercom"></i></span>
	        <ul class="sub-menu">
				<router-link tag="li" class="hide_after_click" :to="{ name: 'allauditdetails'}" v-if="checkUserPermission('audit_similar_user') && checkUserPermission('audit_look_alike_domain') && checkUserPermission('audit_first_time_mail') && checkUserPermission('audit_has_words')">
							<a>All Banners</a>
							<span class="icon-thumbnail"><i class="pg-icon">S</i></span>
						</router-link>
	        	<router-link tag="li" class="hide_after_click" :to="{ name: 'auditdetails',params:{type:'similarUser'}}" v-if="checkUserPermission('audit_similar_user')">
							<a>Similar Sender Name</a>
							<span class="icon-thumbnail"><i class="pg-icon">S</i></span>
						</router-link>
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'auditdetails',params:{type:'lookLikeDomain'}}" v-if="checkUserPermission('audit_look_alike_domain')">
							<a>Similar Domain</a>
							<span class="icon-thumbnail"><i class="pg-icon">S</i></span>
	        	</router-link>
	        	<router-link tag="li" class="hide_after_click" :to="{ name: 'auditdetails',params:{type:'firstTimeMail'}}" v-if="checkUserPermission('audit_first_time_mail')">
							<a>First Time Mail</a>
							<span class="icon-thumbnail"><i class="pg-icon">F</i></span>
	        	</router-link> 
						<router-link tag="li" class="hide_after_click" :to="{ name: 'auditdetails',params:{type:'hasWords'}}" v-if="checkUserPermission('audit_has_words')" >
							<a>Suspicious Keywords</a>
							<span class="icon-thumbnail"><i class="pg-icon">H</i></span>
	        	</router-link>
				<router-link tag="li" class="hide_after_click" :to="{ name: 'esaautoactionlogs'}" v-if="checkUserPermission('settings_esa_auto_action')" ><!-- will add diffrenet permission if required -->
							<a>Auto Action</a>
							<span class="icon-thumbnail"><i class="pg-icon">A</i></span>
	        	</router-link>
				<router-link tag="li" class="hide_after_click" :to="{ name: 'marksafelogs'}" v-if="checkUserPermission('audit_similar_user') && checkUserPermission('audit_look_alike_domain') && checkUserPermission('audit_first_time_mail') && checkUserPermission('audit_has_words')">
							<a>Marksafe List</a>
							<span class="icon-thumbnail"><i class="pg-icon">M</i></span>
						</router-link>
	        	<!--<router-link tag="li" class="hide_after_click" :to="{ name: 'audittotal'}" v-if="checkUserPermission('audit_total')" >
							<a>License Utilisation</a>
							<span class="icon-thumbnail"><i class="pg-icon">L</i></span>
	        	</router-link> -->
	        </ul>
	      </li>

	      <li class="m-t-10" v-if="checkUserPermission('settings_email_logs') || checkUserPermission('settings_campaignmail_logs') || checkUserPermission('settings_admin_activity') ||  checkUserPermission('settings_malicious_logs') || checkUserPermission('settings_multi_auto_action_logs')">
	        <a><span class="title">Logs</span>
	        <span class="arrow"></span></a>
	        <span class="icon-thumbnail"><i class="fas fa-file-contract"></i></span>
	        <ul class="sub-menu">
						<router-link  v-if="checkUserPermission('settings_email_logs')" tag="li" class="hide_after_click" :to="{ name: 'emaillogs'}" >
							<a>Email Logs</a>
							<span class="icon-thumbnail"><i class="pg-icon">E</i></span>
						</router-link>
				<router-link  v-if="checkUserPermission('settings_campaignmail_logs')" tag="li" class="hide_after_click" :to="{ name: 'campaignmaillogs'}" >
							<a>Campaign Mail Logs</a>
							<span class="icon-thumbnail"><i class="pg-icon">C</i></span>
						</router-link> 
	          <router-link  v-if="checkUserPermission('settings_admin_activity')"  tag="li" class="hide_after_click" :to="{ name: 'adminactivity'}">
							<a>Admin Activity</a>
							<span class="icon-thumbnail"><i class="pg-icon">A</i></span>
	        	</router-link> 
						<router-link tag="li" class="hide_after_click" :to="{ name: 'logs',params:{type:'malicious-banner'}}" v-if=" checkUserPermission('settings_malicious_logs') && selected_domain.domain_provider !=1 ">
							<a>Malicious Banner</a>
							<span class="icon-thumbnail"><i class="pg-icon">MB</i></span>
	        	</router-link>
						<router-link tag="li" class="hide_after_click" :to="{ name: 'logs',params:{type:'bulkAutoAction'}}" v-if=" checkUserPermission('settings_multi_auto_action_logs') && selected_domain.domain_provider != 1 ">
							<a>Multi Auto Action Logs</a>
							<span class="icon-thumbnail"><i class="pg-icon">MAL</i></span>
	        	</router-link>
	        </ul>
	      </li>

		  <li class="m-t-10" v-if="checkUserPermission('settings_insights')  && selected_domain.domain_provider !=1 ">
	        <a><span class="title">Email Security Assistant</span>
	        <span class="arrow"></span></a>
	        <span class="icon-thumbnail"><i class="fab fa-intercom"></i></span>
	        <ul class="sub-menu">
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'email_security_assistant'}">
	            <a>Settings</a>
	            <span class="icon-thumbnail"><i class="pg-icon">E</i></span>
	          </router-link>
			   <router-link tag="li" class="hide_after_click" :to="{ name: 'manage_subscriptions'}" v-if="checkInsightCondition">
	            <a>Manage Banner Subscriptions</a>
	            <span class="icon-thumbnail"><i class="pg-icon">M</i></span>
	          </router-link>
			   <router-link tag="li" class="hide_after_click" :to="{ name: 'manage_subscriptions_autoaction', params: {type: 'score'}}" v-if="checkInsightCondition && checkUserPermission('settings_esa_auto_action')">
	            <a>Manage Score Based Subscriptions</a>
	            <span class="icon-thumbnail"><i class="pg-icon">M</i></span>
	          </router-link>
			    
			  
	        </ul>
			
	      </li>


	      <li v-if="general_settings_permissions || personalise_settings_permissions || checkUserPermission('settings_domain_login_user')">
	        <a><span class="title">Settings</span>
	        <span class="arrow"></span></a>
	        <span class="icon-thumbnail"><i class="fas fa-cog"></i></span>
	        <ul class="sub-menu">
			  		<router-link tag="li" class="hide_after_click" :to="{ name: 'general_settings'}" v-if="general_settings_permissions" >
	            <a>General</a>
	            <span class="icon-thumbnail"><i class="pg-icon">G</i></span>
	          </router-link>
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'personalize_settings'}" v-if="personalise_settings_permissions">
	            <a>Personalise</a>
	            <span class="icon-thumbnail"><i class="pg-icon">P</i></span>
	          </router-link>
	         
	          <!--<router-link tag="li" class="hide_after_click" :to="{ name: 'setrules'}" v-if="checkUserPermission('settings_insights')  && selected_domain.domain_provider !=1 ">
	            <a>Remediation Rules</a>
	            <span class="icon-thumbnail"><i class="pg-icon">E</i></span>
	          </router-link>
			  <router-link tag="li" class="hide_after_click" :to="{ name: 'getrules'}" v-if="checkUserPermission('settings_insights')  && selected_domain.domain_provider !=1 ">
	            <a>Remediation Rules History</a>
	            <span class="icon-thumbnail"><i class="pg-icon">E</i></span>
	          </router-link>-->			  
	          <router-link tag="li" class="hide_after_click" :to="{ name: 'admin_users'}" v-if="checkUserPermission('settings_domain_login_user')">
	            <a>Admin Users</a>
	            <span class="icon-thumbnail"><i class="pg-icon">A</i></span>
	          </router-link>
	        </ul>	        
	      </li>

	    </ul>
	  </div>
	</nav>
</template>




// WEBPACK FOOTER //
// src/components/root/sidebar.vue